import { UseMode } from "safe"
import { getRoutes } from "./routes"

export const userConfigJSON = {
  default: {
    country: 'VENEZUELA',
    city: 'MARACAIBO',
    province: 'ZULIA',
    PC: '4005',
    phoneCode: '+58',
  },
  rowsPerPage: 10,
}

export const tax = 16
export const dolarPrice = 4.75
export const marginTopOfPdf = 5

export const useMode: UseMode = "NOVICE"

export const docs = [
  {
    value: 'V',
    text: 'V',
  },
  {
    value: 'J',
    text: 'J',
  },
  {
    value: 'E',
    text: 'E',
  },
  {
    value: 'P',
    text: 'P',
  },
  {
    value: 'G',
    text: 'G',
  },
  {
    value: 'C',
    text: 'C',
  },
]
